import { useState } from 'react';
import { http } from '../../lib/api';
import { AppLayout } from '../../components/layout';
import { Button, Card, Input } from '../../components/core';
import { useAuthStore } from '../../store/auth';
import { ADMIN_NAV } from './nav';

export function AdminProfilePage() {
  const auth = useAuthStore();
  const user = auth.user;
  const [curPw, setCurPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const initials = user ? user.email.slice(0, 2).toUpperCase() : '—';

  const changePw = async () => {
    if (!curPw || !newPw) return;
    if (newPw !== confirmPw) { setMsg('Passwords do not match'); return; }
    if (newPw.length < 8) { setMsg('Min 8 characters'); return; }
    setSaving(true);
    try {
      await http.post('/api/auth/password/change', { currentPassword: curPw, newPassword: newPw });
      setMsg('Password updated'); setCurPw(''); setNewPw(''); setConfirmPw('');
    } catch (e) { setMsg('Error: ' + ((e as Error).message ?? 'Failed')); }
    setSaving(false);
  };

  const logout = async () => {
    try { await http.post('/api/auth/logout'); } catch { /* ignore */ }
    auth.clear(); window.location.href = '/login';
  };

  return (
    <AppLayout brand="LiveStreamX" navGroups={ADMIN_NAV} variant="admin">
      <div className="admin-page">
        <div className="page-header admin-page-header">
          <div><h1 className="page-title">Profile</h1><p className="page-subtitle">Your account settings</p></div>
        </div>
        <div className="profile-grid">
          <Card className="profile-hero">
            <div className="profile-avatar-lg">{initials}</div>
            <div className="profile-meta">
              <h2>{user?.email ?? '—'}</h2>
              <div className="profile-rows">
                <span className="role-pill">{user?.role ?? '—'}</span>
                <span className="badge status-active"><span className="dot" />Active</span>
              </div>
            </div>
            <div style={{ marginTop: 'auto' }}>
              <Button variant="danger" onClick={logout}>Log Out</Button>
            </div>
          </Card>
          <Card title="Change Password">
            <div className="stack">
              <Input label="Current Password" type="password" value={curPw} onChange={setCurPw} required />
              <Input label="New Password" type="password" value={newPw} onChange={setNewPw} required hint="Min 8 characters" />
              <Input label="Confirm New Password" type="password" value={confirmPw} onChange={setConfirmPw} required />
              {msg && <p className="text-sm" style={{ color: msg.startsWith('Error') ? 'var(--danger)' : 'var(--success)', margin: 0 }}>{msg}</p>}
              <div><Button onClick={changePw} disabled={saving}>{saving ? 'Saving…' : 'Update Password'}</Button></div>
            </div>
          </Card>
        </div>
      </div>
    </AppLayout>
  );
}
